"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* global window */
var _default = typeof window !== 'undefined' ? window : undefined;

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-grid-system/build/primitives/Window/index.js
// module id = 1721
// module chunks = 0